export enum DashboardExpenseTypeEnum {
	ASSURANCE = 'ASSURANCE',
	CONTRACTS = 'CONTRACTS',
	MAINTENANCES = 'MAINTENANCES',
	COSTS = 'COSTS',
	FUEL = 'FUEL',
	CLEANING = 'CLEANING',
	FINES = 'FINES',
	ENERGY = 'ENERGY',
	ACCESSORIES = 'ACCESSORIES',
	LOGO = 'LOGO',
	TRANSPORT = 'TRANSPORT',
	MISCELLANEOUS = 'MISCELLANEOUS'
}
